module.exports = __webpack_public_path__ + "img/background.28763216.png";